import type { SVGProps } from 'react';
const SvgFormatStrikethrough = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#format_strikethrough_svg__a)">
      <path
        fill="currentColor"
        d="M10 19h4v-3h-4v3ZM5 4v3h5v3h4V7h5V4H5ZM3 14h18v-2H3v2Z"
      />
    </g>
    <defs>
      <clipPath id="format_strikethrough_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFormatStrikethrough;
